
import Enumerable from "linq";
import { Component, Mixins, Model, Prop, Emit, Watch } from "vue-property-decorator";
import InfiniteLoading from "vue-infinite-loading";
import { WorkflowCommonMixin } from "../../../mixins";
import { DomainRegistry } from "../../../../../domain";
import { InOutKindsName, WorkflowListSortItemKinds } from "../../../../../domain/workflow/kinds";
import { ReceptionDetailSummary } from "../../../../../domain/workflow/list";
import { StandardOption } from "../../../../system/selectors/mixins";
import { Comparator } from "../../../../../domain/system";
import { SortOrder } from "element-ui/types/table";
import { ISortParameter } from "../../../../system";
import { Table } from "element-ui";
import { ReceptionDetailListColor } from "../../../../../domain/workflow/items";
import { ReceptionDetailPresetSortCondition, ReceptionDetailPresetSortConditionItem } from "../../../../../domain/workflow/search";
import ListMultiSortConditionDialog, {
  IListMultiSortConditionDialogParameter,
  IListMultiSortConditionDialogResult,
} from "../../../../document/dialogs/ListMultiSortConditionDialog.vue";
import { ReceptionDateTranslator } from "../../../../../domain/workflow";
import { IWorkflowTableSortParameter } from "../IWorkflowTableSortParameter";
import { ReceptionDetailSummaryValidator, ReceptionDetailSummaryValidatorUtility } from "../models";

/**
 * ワークフローテーブル用Mixin
 */
@Component
export default class WorkflowTableMixin extends Mixins(WorkflowCommonMixin) {
  @Model("input")
  value: ReceptionDetailSummary;

  @Prop()
  details: ReceptionDetailSummary[];

  @Prop({ default: "公開" })
  generalFlag1LabelName: string;

  @Prop()
  isFinishList: boolean;

  @Prop()
  overLimitMessage: string;

  @Prop({default: 50 })
  loadChunkSize: number;

  @Prop()
  displayColor: ReceptionDetailListColor;

  @Prop({ default: false })
  isPaperNameEnable: boolean;

  @Prop({ default: false })
  isPaperCompanyNameEnable: boolean;

  @Prop({ default: true })
  isReceptionAccessible: boolean;

  @Prop()
  isInOutTypeEnable: boolean;

  @Prop()
  defaultSortType: string;

  @Prop()
  defaultOrderType: SortOrder;

  @Prop({ default: false })
  isReadOnly: boolean;

  @Prop()
  highlightedManagerId: string;

  @Prop({ default: false })
  isAdmin: boolean;

  @Emit()
  ready(): void {}

  @Emit()
  input(value: ReceptionDetailSummary): any {}

  @Emit()
  generalFlagUpdated(): void {}

  @Emit()
  orderInitialized(parameter: IWorkflowTableSortParameter): void {}

  @Emit()
  orderChanged(parameter: IWorkflowTableSortParameter): void {}

  data(): any {
    return {
      chunkedCount: 0,
      loadedDetails: [],
      selectedDetail: this.value,
      enableSortItemKinds: [
        WorkflowListSortItemKinds.CreateDate,
        WorkflowListSortItemKinds.UpdateDate,
        WorkflowListSortItemKinds.PatientId,
        WorkflowListSortItemKinds.PatientKana,
        WorkflowListSortItemKinds.FormatName,
        WorkflowListSortItemKinds.CompanyName,
        WorkflowListSortItemKinds.ReceptionNumber,
        WorkflowListSortItemKinds.InputSection,
        WorkflowListSortItemKinds.CreateUser,
        WorkflowListSortItemKinds.DepartmentName,
        WorkflowListSortItemKinds.Manager,
        WorkflowListSortItemKinds.ReceptionDate,
        WorkflowListSortItemKinds.InOutType,
      ],
      allSortTypeOptions: [
        new StandardOption<WorkflowListSortItemKinds>("依頼登録日", WorkflowListSortItemKinds.CreateDate),
        new StandardOption<WorkflowListSortItemKinds>("最終更新日", WorkflowListSortItemKinds.UpdateDate),
        new StandardOption<WorkflowListSortItemKinds>("患者番号", WorkflowListSortItemKinds.PatientId),
        new StandardOption<WorkflowListSortItemKinds>("カナ", WorkflowListSortItemKinds.PatientKana),
        new StandardOption<WorkflowListSortItemKinds>("氏名", WorkflowListSortItemKinds.PatientNameKanji),
        new StandardOption<WorkflowListSortItemKinds>("手書き", WorkflowListSortItemKinds.IsPaper),
        new StandardOption<WorkflowListSortItemKinds>(this.$wording.format.name + "名", WorkflowListSortItemKinds.FormatName),
        new StandardOption<WorkflowListSortItemKinds>(this.$wording.format.attributes.company + "名", WorkflowListSortItemKinds.CompanyName),
        new StandardOption<WorkflowListSortItemKinds>("受付番号", WorkflowListSortItemKinds.ReceptionNumber),
        new StandardOption<WorkflowListSortItemKinds>("入力部署", WorkflowListSortItemKinds.InputSection),
        new StandardOption<WorkflowListSortItemKinds>("作成者", WorkflowListSortItemKinds.CreateUser),
        new StandardOption<WorkflowListSortItemKinds>(this.$wording.common.department, WorkflowListSortItemKinds.DepartmentName),
        new StandardOption<WorkflowListSortItemKinds>("対応責任者", WorkflowListSortItemKinds.Manager),
        new StandardOption<WorkflowListSortItemKinds>("進捗", WorkflowListSortItemKinds.WaitName),
        new StandardOption<WorkflowListSortItemKinds>("一時保存", WorkflowListSortItemKinds.TemporarySave),
        new StandardOption<WorkflowListSortItemKinds>("差戻", WorkflowListSortItemKinds.Status),
        new StandardOption<WorkflowListSortItemKinds>("期限", WorkflowListSortItemKinds.TimeLimit),
        new StandardOption<WorkflowListSortItemKinds>("交付情報", WorkflowListSortItemKinds.Delivery),
        new StandardOption<WorkflowListSortItemKinds>(this.generalFlag1LabelName, WorkflowListSortItemKinds.GeneralFlag1),
        new StandardOption<WorkflowListSortItemKinds>("受付日", WorkflowListSortItemKinds.ReceptionDate),
        new StandardOption<WorkflowListSortItemKinds>("作成期限", WorkflowListSortItemKinds.CreateLimitDate),
        new StandardOption<WorkflowListSortItemKinds>("交付期限", WorkflowListSortItemKinds.DeliveryLimitDate),
        new StandardOption<WorkflowListSortItemKinds>("完了日", WorkflowListSortItemKinds.FinishDate),
        new StandardOption<WorkflowListSortItemKinds>("伝達事項", WorkflowListSortItemKinds.NextMessage),
        new StandardOption<WorkflowListSortItemKinds>("コメント", WorkflowListSortItemKinds.GeneralComment),
        new StandardOption<WorkflowListSortItemKinds>("受取日", WorkflowListSortItemKinds.ReceiptDate),
        new StandardOption<WorkflowListSortItemKinds>("入院/外来", WorkflowListSortItemKinds.InOutType),
      ],
      sortType: null,
      orderType: null,

      orderTypeAsc: "ascending",
      orderTypeDesc: "descending",
      sortParameter: null,
      selectedSortConditionItems: [],
      presetSortConditions: [],
      sortConditions: "",
      isRestoredSortOrder: false,
      filter: undefined,
    };
  }
  chunkedCount: number;
  loadedDetails: ReceptionDetailSummary[];
  selectedDetail: ReceptionDetailSummary;
  enableSortItemKinds: WorkflowListSortItemKinds[];
  allSortTypeOptions: StandardOption<WorkflowListSortItemKinds>[];
  sortType: WorkflowListSortItemKinds;
  isRestoredSortOrder: boolean;
  filter: ReceptionDetailSummaryValidator | undefined;

  orderType: SortOrder;
  orderTypeAsc: SortOrder;
  orderTypeDesc: SortOrder;

  sortParameter: ISortParameter;
  selectedSortConditionItems: ReceptionDetailPresetSortConditionItem[];
  presetSortConditions: ReceptionDetailPresetSortCondition[];
  sortConditions: string;

  dateTranslator: ReceptionDateTranslator;

  $refs!: {
    elTable: Table;
    sortConditionDialog: ListMultiSortConditionDialog<WorkflowListSortItemKinds>;
  };

  created(): void {
    this.dateTranslator = new ReceptionDateTranslator();
  }

  async mounted() {
    this.setDefaultSortAndOrder();
    if (this.details.length > 0) {
      this.execSort(this.details);
      this.updateSortParameter();
    }
    await this.initializePresetSortCondition();
    this.orderInitialized(this.workflowTableSortParameter);
  }

  private async initializePresetSortCondition(): Promise<void> {
    try {
      const repository = DomainRegistry.workflow.getWorkflowRepository();
      const result = await repository.getPresetSortCondition();
      this.presetSortConditions = result;
      const index = this.presetSortConditions.findIndex(v => v.isDefault);
      if (index !== -1) {
        this.setPresetSortType(index);
      }
    } catch (e) {
      this.showRequestErrorMessage("ソート条件プリセット情報取得エラー", "ソート条件のプリセット情報取得処理に失敗しました。", e);
    } finally {
      this.ready();
    }
  }

  private setPresetSortType(index: number): void {
    this.sortType = WorkflowListSortItemKinds.PresetMin + index;
  }

  setDefaultSortAndOrder(): void {
    if (this.defaultSortType) {
      const sortTypeItem = Enumerable.from(this.enableSortItemKinds)
        .firstOrDefault(o => o === Enumerable.from(this.allSortTypeOptions)
          .where(s => s.label === this.defaultSortType)
          .select(s => s.value)
          .firstOrDefault());
      this.sortType = sortTypeItem ? sortTypeItem : WorkflowListSortItemKinds.ReceptionDate;
      this.orderType = this.defaultOrderType ? this.defaultOrderType : this.orderTypeDesc;
    } else {
      this.sortType = WorkflowListSortItemKinds.ReceptionDate;
      this.orderType = this.orderTypeDesc;
    }
  }

  get isFilterVisible(): boolean {
    const configuration = this.$configuration.behavior.reception.list.filter;
    return configuration.isEnable
        && configuration.filters.filter(f => !f.target || (f.target === "workflow" && this.isAdmin) || (f.target === "todo" && !this.isAdmin)).length > 1;
  }

  createFilterUtility(): ReceptionDetailSummaryValidatorUtility {
    const now = new Date();
    return {
      today: new Date(now.getFullYear(), now.getMonth(), now.getDate()),
      toDaysAdded: (s: Date, d: number) => new Date(now.getFullYear(), now.getMonth(), now.getDate() + d),      
    };
  }

  get filteredLoadedDetails(): ReceptionDetailSummary[] {
    return this.filterDetails(this.loadedDetails);  }

  get filteredDetails(): ReceptionDetailSummary[] {
    return this.filterDetails(this.details);
  }

  filterDetails(source: ReceptionDetailSummary[]) {
    const utility = this.createFilterUtility();
    return source.filter(d => this.isFilterPassed(d, utility));
  }

  isFilterPassed(source: ReceptionDetailSummary, utility: ReceptionDetailSummaryValidatorUtility): boolean {
    return !this.filter || this.filter(source, utility);  }

  get filteredDetailCount(): number {
    return this.filteredDetails.length;
  }

  get hasDetails(): boolean {
    return 0 < this.detailCount;
  }

  get detailCount(): number {
    return this.details.length;
  }

  get sortTypeOptions(): StandardOption<WorkflowListSortItemKinds>[] {
    return this.multiConditionSortTypeOptions.concat(this.presetSortTypeOptions, Enumerable.from(this.enableSortItemKinds)
      .select(o => this.getSortTypeOptions(o))
      .where(o => o !== null)
      .toArray());
  }

  private getSortTypeOptions(s: WorkflowListSortItemKinds): StandardOption<WorkflowListSortItemKinds> {
    return Enumerable.from(this.allSortTypeOptions)
      .firstOrDefault(o => o.value === s);
  }

  protected chunkList(infiniteLoading: InfiniteLoading): void {
    const utility = this.createFilterUtility();
    for (let i = this.chunkedCount, visibleCount = 0; visibleCount < this.loadChunkSize; i++) {
      if (i >= this.details.length) {
        console.log("call complete. i is " + i);
        this.chunkedCount = this.details.length;
        infiniteLoading.stateChanger.complete();
        return;
      }

      this.loadedDetails.push(this.details[i]);
      if (this.isFilterPassed(this.details[i], utility)) {
        visibleCount++;
      }
    }
    this.chunkedCount += this.loadChunkSize;

    console.log("call loaded. chunkedCount is " + this.chunkedCount);
    infiniteLoading.stateChanger.loaded();
  }

  // ローディング状態をリセット
  resetChunkList(infiniteLoading: InfiniteLoading): void {
    this.loadedDetails = [];
    this.chunkedCount = 0;

    if (infiniteLoading) {
      console.log("call reset.");
      infiniteLoading.stateChanger.reset();
    }
  }

  isFinishStatus(row: ReceptionDetailSummary): boolean {
    return !!row.finishDate;
  }

  toManagerStyle(source: ReceptionDetailSummary): any {
    return {
      color: this.highlightedManagerId ? this.getManagerHighlightColor(source) : "",
    };
  }

  getManagerHighlightColor(source: ReceptionDetailSummary): string {
    return (source.managers && source.managers.length > 0 && source.managers.some(m => m.id === this.highlightedManagerId))
      ? "#0000FF"
      : "#FF0000";
  }

  showRequestListView(): void {
    const param: any = {
      patientNo: this.selectedDetail.patient.id,
      receptionId: this.selectedDetail.receptionId,
      receptionDetailId: this.selectedDetail.id,
      isPatientFixed: true,
    };
    this.$openWindow("/WorkflowReception", param);
  }

  // 患者指定の過去一覧画面表示
  showDocumentListView(): void {
    const param: any = {
      patientNo: this.selectedDetail.patient.id,
    };
    this.$openWindow("/ShowPatientDocumentList", param);
  }

  toDisplayNextMessage(row: ReceptionDetailSummary): string {
    if (!row.nextMessages || row.nextMessages.length < 1) { return ""; }
    return row.nextMessages[0]
      + ((1 < row.nextMessages.length) ? "（他" + (row.nextMessages.length - 1) + "件）" : "");
  }

  toDisplayGeneralComment(row: ReceptionDetailSummary): string {
    if (!row.generalComments || row.generalComments.length < 1) { return ""; }
    return row.generalComments[0]
      + ((1 < row.generalComments.length) ? "（他" + (row.generalComments.length - 1) + "件）" : "");
  }

  // --------- 一覧ソート -----------------------------------------

  get isMultiConditionSortTypeOption(): boolean {
    return this.sortType === WorkflowListSortItemKinds.MultiCondition;
  }

  get multiConditionSortTypeOptions(): StandardOption<WorkflowListSortItemKinds>[] {
    return [new StandardOption<WorkflowListSortItemKinds>("複数条件", WorkflowListSortItemKinds.MultiCondition)];
  }

  get isPresetSortTypeOption(): boolean {
    return this.sortType === Math.min(Math.max(this.sortType, WorkflowListSortItemKinds.PresetMin), WorkflowListSortItemKinds.PresetMax);
  }

  get presetSortTypeOptions(): StandardOption<WorkflowListSortItemKinds>[] {
    return Enumerable.from(this.presetSortConditions)
      .select((e, i) => new StandardOption<WorkflowListSortItemKinds>(e.label, WorkflowListSortItemKinds.PresetMin + i))
      .toArray();
  }

  get presetSortCondition(): ReceptionDetailPresetSortCondition {
    return this.presetSortConditions[this.presetSortConditionIndex];
  }

  get presetSortConditionIndex(): number {
    return this.sortType - WorkflowListSortItemKinds.PresetMin;
  }

  get selectedSortConditions(): string {
    const sortConditionItems = Enumerable.from(this.selectedSortConditionItems)
      .select((s) => {
        const label = Enumerable.from(this.allSortTypeOptions).where(a => a.value === s.sortType).select(a => a.label).firstOrDefault();
        if (label) {
          return label + (s.orderType === "ascending" ? "(昇順)" : "(降順)");
        }
      })
      .toArray();
    this.sortConditions = sortConditionItems.join(" ＞ ");
    return this.sortConditions;
  }

  // ※外部から呼ぶ
  onSearchCompleted(list: ReceptionDetailSummary[], getSelectedDetail: (list: ReceptionDetailSummary[]) => ReceptionDetailSummary): void {
    console.log("called onSearchCompleted..");
    // 外部から呼ばれる場合は前回のsortParameterを初期化する契機がないためここで行う
    this.sortParameter = null;
    this.execSort(list);
    this.updateSortParameter();

    this.handleSelectionChanged(!!getSelectedDetail
      ? getSelectedDetail(list)
      : null);
  }

  handleSelectionChanged(row: ReceptionDetailSummary) {
    // 処理はview側で
  }

  onSortChanged(param: { prop: string, order: SortOrder }): void {
    // sortTypeかorderType更新前にsortParameterを更新した場合、
    // execSortのソート実行スキップ条件でスキップされてしまうため、更新前にソートを実行する。
    this.sortType = Number(param.prop);
    this.orderType = param.order ? param.order : this.orderTypeAsc;
    this.execSort(this.details);
    // element-uiのテーブルソートは ascending → descending → null となるため null の場合は ascending とする
    const parameter: ISortParameter = {
      property: param.prop,
      order: param.order ? param.order : this.orderTypeAsc,
    };
    this.sortParameter = parameter;
  }

  updateSortParameter(): void {
    // 診療科グループと診療科の組み合わせが不正のときは検索せずに０件でリストを更新していて通常よりも早いタイミングでonSearchCompletedが呼ばれ
    // sortType=undefinedでtoString()のエラーになるため、sortTypeの値をチェックしてtoString()している
    const parameter: ISortParameter = {
      property: this.sortType ? this.sortType.toString() : "",
      order: this.orderType,
    };
    this.sortParameter = parameter;
  }

  updateSort(): void {
    const table = this.$refs.elTable;
    if (table && this.sortParameter) {
      table.sort(this.sortParameter.property, this.sortParameter.order);
    }
  }

  @Watch("sortParameter")
  onSortParameterUpdated(newValue: ISortParameter, oldValue: ISortParameter): void {
    if (newValue && (!oldValue || (newValue.property !== oldValue.property || newValue.order !== oldValue.order))) {
      this.sortType = Number(newValue.property);
      this.orderType = newValue.order;
      this.updateSort();
    }
  }

  @Watch("orderType")
  onOrderTypeChanged(newValue: SortOrder, oldValue: SortOrder): void {
    if (!oldValue) { return; }
    if (newValue !== oldValue) {
      this.execSort(this.details);
      this.updateSortParameter();
    }
  }

  @Watch("sortType")
  async onSortTypeChanged(newValue: WorkflowListSortItemKinds, oldValue: WorkflowListSortItemKinds): Promise<void> {
    if (oldValue === null || oldValue === undefined) { return; }
    if (newValue !== oldValue) {
      if (newValue === WorkflowListSortItemKinds.MultiCondition) {
        if (!this.isRestoredSortOrder && !await this.execSortDialog(this.toMultiConditionSortDialogParam(oldValue))) {
          this.sortType = oldValue;
        }
      } else if (newValue === Math.min(Math.max(newValue, WorkflowListSortItemKinds.PresetMin), WorkflowListSortItemKinds.PresetMax)) {
        this.selectedSortConditionItems = this.presetSortCondition.items;
        this.execSort(this.details);
      } else {
        this.selectedSortConditionItems = [];
        this.execSort(this.details);
        this.updateSortParameter();
      }
    }
  }

  showSortDialog(): void {
    this.execSortDialog(this.isMultiConditionSortTypeOption
      ? this.toMultiConditionSortDialogParam()
      : this.toPresetSortDialogParam());
  }

  private toMultiConditionSortDialogParam(sortType: WorkflowListSortItemKinds = this.sortType): IListMultiSortConditionDialogParameter<WorkflowListSortItemKinds> {
    return {
      isEdit: false,
      presetName: "",
      sortConditionItems: this.selectedSortConditionItems.length > 0
        ? this.selectedSortConditionItems
        : [{ sortType: sortType, orderType: this.orderType }],
      sortTypeOptions: this.allSortTypeOptions,
      defaultSort: false,
      isSortButtonEnable: true,
    };
  }

  private toPresetSortDialogParam(): IListMultiSortConditionDialogParameter<WorkflowListSortItemKinds> {
    return {
      isEdit: true,
      presetName: this.presetSortCondition.label,
      sortConditionItems: this.presetSortCondition.items,
      sortTypeOptions: this.allSortTypeOptions,
      defaultSort: this.presetSortCondition.isDefault,
      isSortButtonEnable: true,
    };
  }

  private async execSortDialog(param: IListMultiSortConditionDialogParameter<WorkflowListSortItemKinds>): Promise<boolean> {
    const ret = await this.$refs.sortConditionDialog.show(param);
    await this.execSortDialogResult(ret);
    return ret.result !== "cancel";
  }

  private async execSortDialogResult(result: IListMultiSortConditionDialogResult): Promise<void> {
    switch (result.result) {
      case "sort":
        this.selectedSortConditionItems = result.sortConditionItems;
        this.execSort(this.details);
        break;
      case "add":
        const model = new ReceptionDetailPresetSortCondition();
        model.label = result.presetName;
        model.items = result.sortConditionItems;
        model.isDefault = result.defaultSort;
        if (result.defaultSort) {
          this.presetSortConditions.forEach(v => v.isDefault = false);
        }
        this.presetSortConditions.push(model);
        this.setPresetSortType(this.presetSortConditions.length - 1);
        this.registerPresetSortCondition();
        break;
      case "rename":
        this.presetSortCondition.label = result.presetName;
        this.registerPresetSortCondition();
        break;
      case "remove":
        this.presetSortConditions.splice(this.presetSortConditionIndex, 1);
        this.registerPresetSortCondition();
        this.setDefaultSortAndOrder();
        this.orderInitialized(this.workflowTableSortParameter);
        break;
      case "update":
        this.presetSortCondition.label = result.presetName;
        this.presetSortCondition.items = result.sortConditionItems;
        if (result.defaultSort) {
          this.presetSortConditions.forEach(v => v.isDefault = false);
        }
        this.presetSortCondition.isDefault = result.defaultSort;
        this.registerPresetSortCondition();
        this.selectedSortConditionItems = result.sortConditionItems;
        this.execSort(this.details);
        break;
    }
  }

  private async registerPresetSortCondition(): Promise<void> {
    try {
      const repository = DomainRegistry.workflow.getWorkflowRepository();
      await repository.registerPresetSortCondition(this.presetSortConditions);
    } catch (e) {
      this.showRequestErrorMessage("ソート条件プリセット情報登録エラー", "ソート条件のプリセット情報登録処理に失敗しました。", e);
    }
  }

  get workflowTableSortParameter(): IWorkflowTableSortParameter {
    return {
      sortType: this.sortType,
      orderType: this.orderType,
      sortConditionItems: this.selectedSortConditionItems,
    };
  }

  execSort(list: ReceptionDetailSummary[]): void {
    this.orderChanged(this.workflowTableSortParameter);
    if (this.sortType === WorkflowListSortItemKinds.MultiCondition || this.sortType === Math.min(Math.max(this.sortType, WorkflowListSortItemKinds.PresetMin), WorkflowListSortItemKinds.PresetMax)) {
      this.execDimensionalSort(list);
    } else {
      this.execSingleSort(list);
    }
  }

  execSingleSort(list: ReceptionDetailSummary[]): void {
    if (this.sortParameter && this.sortParameter.property === this.sortType.toString() && this.sortParameter.order === this.orderType) { return; }
    console.log("sort " + WorkflowListSortItemKinds[this.sortType] + " " + this.getOrderString(this.orderType));
    switch (this.sortType) {
      case WorkflowListSortItemKinds.CreateLimitDate:
      case WorkflowListSortItemKinds.DeliveryLimitDate:
        if (this.isFinishList) {
          // tableに存在しない項目の場合、項目ソートのマークが残ってしまうためtableソートのクリアを行う
          this.$refs.elTable.clearSort();
        }
        break;
      case WorkflowListSortItemKinds.FinishDate:
        if (!this.isFinishList) {
          // tableに存在しない項目の場合、項目ソートのマークが残ってしまうためtableソートのクリアを行う
          this.$refs.elTable.clearSort();
        }
        break;
    }
    list.sort((a, b) => {
      const ret = this.getCompare(this.sortType, this.orderType)(a, b);
      if (ret !== 0) {
        return ret;
      }
      // ソート結果が同じだったので、最終更新日時でソート
      return this.getCompareWithLastUpdate(this.sortType, this.orderType)(a, b);
    });
  }

  execDimensionalSort(list: ReceptionDetailSummary[]) {
    const items = this.selectedSortConditionItems.filter(v => v.sortType !== null && v.orderType !== null);
    const lastIndex = items.length - 1;
    console.log("dimensional sort " + items
      .map(v => WorkflowListSortItemKinds[v.sortType] + " " + this.getOrderString(v.orderType))
      .join(" - "));
    // 項目ソートのマークが残ってしまうためtableソートのクリアを行う
    this.$refs.elTable.clearSort();
    // sortParameterが残っていると複数条件を削除した後にソートが動作しないためクリアする
    this.sortParameter = null;
    list.sort((a, b) => {
      for (const item of items) {
        const ret = this.getCompare(item.sortType, item.orderType)(a, b);
        if (ret !== 0) {
          return ret;
        }
      }
      // ソート結果が同じだったので、最終更新日時でソート
      return this.getCompareWithLastUpdate(items[lastIndex].sortType, items[lastIndex].orderType)(a, b);
    });
  }

  updateSortOrder(parameter: IWorkflowTableSortParameter): void {
    this.isRestoredSortOrder = true; // ソート条件を復元したときにonSortTypeChangedで複数条件設定ダイアログが起動するのを防ぐために使用(TodoListViewでソート条件を復元している)
    this.selectedSortConditionItems = parameter.sortConditionItems;
    this.sortType = parameter.sortType;
    this.orderType = parameter.orderType;
    this.$nextTick(() => this.isRestoredSortOrder = false);
  }

  private getCompare(sortType: WorkflowListSortItemKinds, orderType: SortOrder): (a: ReceptionDetailSummary, b: ReceptionDetailSummary) => number {
    switch (sortType) {
      case WorkflowListSortItemKinds.ReceptionDate:
        return this.getCompareReceptionDate(orderType);
      case WorkflowListSortItemKinds.CreateDate:
        return this.getCompareCreateDate(orderType);
      case WorkflowListSortItemKinds.UpdateDate:
        return this.getCompareUpdateDate(orderType);
      case WorkflowListSortItemKinds.PatientId:
        return this.getComparePatientId(orderType);
      case WorkflowListSortItemKinds.PatientKana:
        return this.getComparePatientKana(orderType);
      case WorkflowListSortItemKinds.CompanyName:
        return this.getCompareCompanyName(orderType);
      case WorkflowListSortItemKinds.FormatName:
        return this.getCompareFormatName(orderType);
      case WorkflowListSortItemKinds.DepartmentName:
        return this.getCompareDepartmentName(orderType);
      case WorkflowListSortItemKinds.Manager:
        return this.getCompareManager(orderType);
      case WorkflowListSortItemKinds.CreateUser:
        return this.getCompareCreateUser(orderType);
      case WorkflowListSortItemKinds.ReceptionNumber:
        return this.getCompareReceptionNumber(orderType);
      case WorkflowListSortItemKinds.InputSection:
        return this.getCompareInputSection(orderType);
      case WorkflowListSortItemKinds.PatientNameKanji:
        return this.getComparePatientNameKanji(orderType);
      case WorkflowListSortItemKinds.WaitName:
        return this.getCompareStatusCode(orderType);
      case WorkflowListSortItemKinds.Status:
        return this.getCompareStatus(orderType);
      case WorkflowListSortItemKinds.TimeLimit:
        return this.getCompareTimeLimit(orderType);
      case WorkflowListSortItemKinds.Delivery:
        return this.getCompareDelivery(orderType);
      case WorkflowListSortItemKinds.GeneralFlag1:
        return this.getCompareGeneralFlag1(orderType);
      case WorkflowListSortItemKinds.TemporarySave:
        return this.getCompareTemporarySave(orderType);
      case WorkflowListSortItemKinds.CreateLimitDate:
        return this.getCompareCreateLimitDate(orderType);
      case WorkflowListSortItemKinds.DeliveryLimitDate:
        return this.getCompareDeliveryLimitDate(orderType);
      case WorkflowListSortItemKinds.FinishDate:
        return this.getCompareFinishDate(orderType);
      case WorkflowListSortItemKinds.IsPaper:
        return this.getCompareIsPaper(orderType);
      case WorkflowListSortItemKinds.NextMessage:
        return this.getCompareNextMessage(orderType);
      case WorkflowListSortItemKinds.GeneralComment:
        return this.getCompareGeneralComment(orderType);
      case WorkflowListSortItemKinds.ReceiptDate:
        return this.getCompareReceiptDate(orderType);
      case WorkflowListSortItemKinds.InOutType:
        return this.getCompareInOutType(orderType);
      default:
        return (a, b) => 0;
    }
  }

  // 受付日（日付まで）
  private getCompareReceptionDate(orderType: SortOrder): (a: ReceptionDetailSummary, b: ReceptionDetailSummary) => number {
    return (a, b) => this.compare(a.receptionDate, b.receptionDate, orderType);
  }

  // 依頼登録日（時間まで取得しているが、表示上は日付のみのため複数条件でソートを行った際に見た目と複数条件のソート結果が合わないことが考えられる。そのため日付まででソートを行う）
  private getCompareCreateDate(orderType: SortOrder): (a: ReceptionDetailSummary, b: ReceptionDetailSummary) => number {
    return (a, b) => this.compare(this.fromDateTimeToDate(a.createDateTime), this.fromDateTimeToDate(b.createDateTime), orderType);
  }

  // 最終更新日（時間まで）
  private getCompareUpdateDate(orderType: SortOrder): (a: ReceptionDetailSummary, b: ReceptionDetailSummary) => number {
    return (a, b) => this.compare(a.updateDateTime, b.updateDateTime, orderType);
  }

  // 患者番号（文字列）
  private getComparePatientId(orderType: SortOrder): (a: ReceptionDetailSummary, b: ReceptionDetailSummary) => number {
    return (a, b) => this.compare(a.patient.id, b.patient.id, orderType);
  }

  // 患者カナ名（文字列）
  private getComparePatientKana(orderType: SortOrder): (a: ReceptionDetailSummary, b: ReceptionDetailSummary) => number {
    return (a, b) => this.compare(a.patient.kanaName, b.patient.kanaName, orderType);
  }

  // 会社名（文字列）
  private getCompareCompanyName(orderType: SortOrder): (a: ReceptionDetailSummary, b: ReceptionDetailSummary) => number {
    // company は null になる可能性があるので。
    return (a, b) => this.compare(this.getCompanyName(a), this.getCompanyName(b), orderType);
  }

  // 文書名（文字列）
  private getCompareFormatName(orderType: SortOrder): (a: ReceptionDetailSummary, b: ReceptionDetailSummary) => number {
    return (a, b) => this.compare(this.getFormatName(a), this.getFormatName(b), orderType);
  }

  // 診療科名（文字列）
  private getCompareDepartmentName(orderType: SortOrder): (a: ReceptionDetailSummary, b: ReceptionDetailSummary) => number {
    return (a, b) => this.compare(this.getDepartmentName(a), this.getDepartmentName(b), orderType);
  }

  // 対応責任者（文字列）
  private getCompareManager(orderType: SortOrder): (a: ReceptionDetailSummary, b: ReceptionDetailSummary) => number {
    return (a, b) => this.compare(this.getManagerName(a), this.getManagerName(b), orderType);
  }

  // 依頼作成者（文字列）
  private getCompareCreateUser(orderType: SortOrder): (a: ReceptionDetailSummary, b: ReceptionDetailSummary) => number {
    return (a, b) => this.compare(this.getCreateUserName(a), this.getCreateUserName(b), orderType);
  }

  // 受付番号（文字列）
  private getCompareReceptionNumber(orderType: SortOrder): (a: ReceptionDetailSummary, b: ReceptionDetailSummary) => number {
    return (a, b) => this.compare(this.getReceptionNumber(a), this.getReceptionNumber(b), orderType);
  }

  // 入力部署（文字列）
  private getCompareInputSection(orderType: SortOrder): (a: ReceptionDetailSummary, b: ReceptionDetailSummary) => number {
    return (a, b) => this.compare(this.getInputSectionName(a), this.getInputSectionName(b), orderType);
  }

  // 氏名（文字列）
  private getComparePatientNameKanji(orderType: SortOrder): (a: ReceptionDetailSummary, b: ReceptionDetailSummary) => number {
    return (a, b) => this.compare(a.patient.name, b.patient.name, orderType);
  }

  // 進捗コード（数値）
  private getCompareStatusCode(orderType: SortOrder): (a: ReceptionDetailSummary, b: ReceptionDetailSummary) => number {
    return (a, b) => this.compare(this.getStatusCode(a), this.getStatusCode(b), orderType);
  }

  // 状態（文字列）
  private getCompareStatus(orderType: SortOrder): (a: ReceptionDetailSummary, b: ReceptionDetailSummary) => number {
    return (a, b) => this.compare(this.getStatusName(a), this.getStatusName(b), orderType);
  }

  // 期限（文字列）
  private getCompareTimeLimit(orderType: SortOrder): (a: ReceptionDetailSummary, b: ReceptionDetailSummary) => number {
    return (a, b) => this.compare(this.getTimeLimitName(a), this.getTimeLimitName(b), orderType);
  }

  // 交付情報（文字列）
  private getCompareDelivery(orderType: SortOrder): (a: ReceptionDetailSummary, b: ReceptionDetailSummary) => number {
    return (a, b) => this.compare(this.getDeliveryName(a), this.getDeliveryName(b), orderType);
  }

  // 公開（文字列）
  private getCompareGeneralFlag1(orderType: SortOrder): (a: ReceptionDetailSummary, b: ReceptionDetailSummary) => number {
    return (a, b) => this.compare(this.getGeneralFlag1Name(a), this.getGeneralFlag1Name(b), orderType);
  }

  // 一時保存（文字列）
  private getCompareTemporarySave(orderType: SortOrder): (a: ReceptionDetailSummary, b: ReceptionDetailSummary) => number {
    return (a, b) => this.compare(this.getTemporarySaveName(a), this.getTemporarySaveName(b), orderType);
  }

  // 作成期限（日付まで）
  private getCompareCreateLimitDate(orderType: SortOrder): (a: ReceptionDetailSummary, b: ReceptionDetailSummary) => number {
    return (a, b) => this.compare
    (
      (a.createLimitDate ? a.createLimitDate : new Date(null)),
      (b.createLimitDate ? b.createLimitDate : new Date(null)),
      orderType
    );
  }

  // 交付期限（日付まで）
  private getCompareDeliveryLimitDate(orderType: SortOrder): (a: ReceptionDetailSummary, b: ReceptionDetailSummary) => number {
    return (a, b) => this.compare
    (
      (a.deliveryLimitDate ? a.deliveryLimitDate : new Date(null)),
      (b.deliveryLimitDate ? b.deliveryLimitDate : new Date(null)),
      orderType
    );
  }

  // 完了日（日付まで）
  private getCompareFinishDate(orderType: SortOrder): (a: ReceptionDetailSummary, b: ReceptionDetailSummary) => number {
    return (a, b) => this.compare
    (
      (a.finishDate ? a.finishDate : new Date(null)),
      (b.finishDate ? b.finishDate : new Date(null)),
      orderType
    );
  }

  // 手書き（文字列）
  private getCompareIsPaper(orderType: SortOrder): (a: ReceptionDetailSummary, b: ReceptionDetailSummary) => number {
    return (a, b) => this.compare
    (
      this.getIsPaperName(a),
      this.getIsPaperName(b),
      orderType
    );
  }

  // 伝達事項（文字列）
  private getCompareNextMessage(orderType: SortOrder): (a: ReceptionDetailSummary, b: ReceptionDetailSummary) => number {
    return (a, b) => {
      const aText = this.toDisplayNextMessage(a);
      const bText = this.toDisplayNextMessage(b);
      return this.compare
      (
        aText,
        bText,
        orderType
      );
    };
  }

  // コメント（文字列）
  private getCompareGeneralComment(orderType: SortOrder): (a: ReceptionDetailSummary, b: ReceptionDetailSummary) => number {
    return (a, b) => {
      const aText = this.toDisplayGeneralComment(a);
      const bText = this.toDisplayGeneralComment(b);
      return this.compare
      (
        aText,
        bText,
        orderType
      );
    };
  }

  // 受取日（日付まで）
  private getCompareReceiptDate(orderType: SortOrder): (a: ReceptionDetailSummary, b: ReceptionDetailSummary) => number {
    return (a, b) => this.compare
    (
      (a.receiptDate ? a.receiptDate : new Date(null)),
      (b.receiptDate ? b.receiptDate : new Date(null)),
      orderType
    );
  }

  // 入外区分
  private getCompareInOutType(orderType: SortOrder): (a: ReceptionDetailSummary, b: ReceptionDetailSummary) => number {
    return (a, b) => this.compare(
      InOutKindsName.getDisplayName(a.inOutType),
      InOutKindsName.getDisplayName(b.inOutType),
      orderType
    );
  }

  private compare(a: any, b: any, orderType: SortOrder): number {
    return Comparator.compare(a, b, orderType === this.orderTypeAsc);
  }

  private fromDateTimeToDate(dateTime: Date): Date {
    return this.dateTranslator.fromDateString(this.dateTranslator.toDateString(dateTime));
  }

  private getCompareWithLastUpdate(sortType: WorkflowListSortItemKinds, orderType: SortOrder): (a: ReceptionDetailSummary, b: ReceptionDetailSummary) => number {
    switch (sortType) {
      case WorkflowListSortItemKinds.ReceptionDate:
        return this.getCompareUpdateDate(orderType);
      case WorkflowListSortItemKinds.PatientId:
      case WorkflowListSortItemKinds.PatientKana:
      case WorkflowListSortItemKinds.CompanyName:
      case WorkflowListSortItemKinds.FormatName:
      case WorkflowListSortItemKinds.DepartmentName:
      case WorkflowListSortItemKinds.Manager:
      case WorkflowListSortItemKinds.CreateUser:
      case WorkflowListSortItemKinds.ReceptionNumber:
      case WorkflowListSortItemKinds.InputSection:
      case WorkflowListSortItemKinds.PatientNameKanji:
      case WorkflowListSortItemKinds.WaitName:
      case WorkflowListSortItemKinds.Status:
      case WorkflowListSortItemKinds.TemporarySave:
      case WorkflowListSortItemKinds.TimeLimit:
      case WorkflowListSortItemKinds.Delivery:
      case WorkflowListSortItemKinds.GeneralFlag1:
      case WorkflowListSortItemKinds.CreateLimitDate:
      case WorkflowListSortItemKinds.DeliveryLimitDate:
      case WorkflowListSortItemKinds.FinishDate:
      case WorkflowListSortItemKinds.IsPaper:
      case WorkflowListSortItemKinds.NextMessage:
      case WorkflowListSortItemKinds.GeneralComment:
      case WorkflowListSortItemKinds.ReceiptDate:
        return this.getCompareUpdateDate(this.orderTypeDesc);
      default:
        return (a, b) => 0;
    }
  }

  private getOrderString(orderType: SortOrder): string {
    return (orderType === this.orderTypeAsc ? "asc" : "desc");
  }

  sortTypeAreEqual(source: WorkflowListSortItemKinds, dest: WorkflowListSortItemKinds): boolean {
    return source === dest;
  }

  private getCompanyName(detail: ReceptionDetailSummary): string {
    return (this.isPaperCompanyNameEnable && detail.isPaper && detail.isPaper.value && detail.paperCompanyName)
      ? detail.paperCompanyName
      : (detail.format && detail.format.company && detail.format.company.name ? detail.format.company.name : "");
  }

  private getFormatName(detail: ReceptionDetailSummary): string {
    return (this.isPaperNameEnable && detail.isPaper && detail.isPaper.value && detail.paperName)
      ? "（手書き）" + detail.paperName
      : (detail.format ? detail.format.name : "");
  }

  private getDepartmentName(detail: ReceptionDetailSummary): string {
    return detail.department ? detail.department.name : "";
  }

  private getManagerName(detail: ReceptionDetailSummary): string {
    return (detail.managers && 0 < detail.managers.length)
      ? Enumerable.from(detail.managers).select(m => m.name).toArray().join(",")
      : "";
  }

  private getCreateUserName(detail: ReceptionDetailSummary): string {
    return detail.createUser ? detail.createUser.name : "";
  }

  private getReceptionNumber(detail: ReceptionDetailSummary): string {
    return detail.receptionNumber ? detail.receptionNumber : "";
  }

  private getInputSectionName(detail: ReceptionDetailSummary): string {
    return detail.inputSection ? detail.inputSection.name : "";
  }

  private getStatusCode(detail: ReceptionDetailSummary): number {
    return detail.status.status.code ? detail.status.status.code : 0;
  }

  private getStatusName(detail: ReceptionDetailSummary): string {
    return detail.isBacked.value ? "差戻" : "";
  }

  private getTemporarySaveName(detail: ReceptionDetailSummary): string {
    return detail.isTemporary.value ? "一時保存" : "";
  }

  private getTimeLimitName(detail: ReceptionDetailSummary): string {
    if (detail.isExpired.value) { return "期限切れ"; }
    if (detail.isNearlyExpired.value) { return detail.isNearlyExpired.labelName + "日前"; }
    return "";
  }

  private getDeliveryName(detail: ReceptionDetailSummary): string {
    return detail.deliveryKind ? detail.deliveryKind : "";
  }

  private getGeneralFlag1Name(detail: ReceptionDetailSummary): string {
    return detail.generalFlag1.value ? this.generalFlag1LabelName : "";
  }

  private getIsPaperName(detail: ReceptionDetailSummary): string {
    return detail.isPaper.value ? "★手書き★" : "";
  }

  // --------- リスト表示色 -----------------------------------------
  get isExpiredBackgroundColor(): string {
    return this.displayColor ? this.displayColor.expiredBackgroundColor : "" ;
  }

  get isNearlyExpiredBackgroundColor(): string {
    return this.displayColor ? this.displayColor.nearlyExpiredBackgroundColor : "";
  }

  get isExpiredForegroundColor(): string {
    return this.displayColor ? this.displayColor.expiredForegroundColor : "";
  }

  get isNearlyExpiredForegroundColor(): string {
    return this.displayColor ? this.displayColor.nearlyExpiredForegroundColor : "";
  }

  get isBackedForegroundColor(): string {
    return this.displayColor ? this.displayColor.backedForegroundColor : "";
  }

  get isTemporaryForegroundColor(): string {
    return this.displayColor ? this.displayColor.temporaryForegroundColor : "";
  }
}
